import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface PropsType {
    className?: string;
    onClick?: () => void;
}

export const LondonBetBrandIcon = observer(
    'LondonBetBrandIcon',
    ({ className, onClick }: PropsType): JSX.Element => (
        <SvgElement
            className={className}
            onClick={onClick}
            fill='none'
            width='26'
            height='24'
            viewBox='0 0 26 24'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M5.36232 0H0.931778V23.617H5.36232V0Z'
                fill='white'
            />
            <path
                d='M12.3648 21.3905C12.3648 22.6183 11.3698 23.617 10.1383 23.617C8.90675 23.617 7.91176 22.622 7.91176 21.3905C7.91176 20.159 8.90675 19.164 10.1383 19.164C11.3698 19.164 12.3648 20.159 12.3648 21.3905Z'
                fill='white'
            />
            <path
                d='M24.132 10.4681C23.5013 9.15395 22.6189 8.13643 21.485 7.41928C20.3473 6.70213 19.0069 6.34168 17.4562 6.34168C16.0407 6.34168 14.8429 6.70213 13.863 7.41928C13.2697 7.85858 12.7891 8.44431 12.3648 9.10138V0H7.91551V18.7472C8.505 18.2816 9.24843 18 10.0594 18C11.9743 18 13.5288 19.5545 13.5288 21.4694C13.5288 21.826 13.4725 22.1715 13.3748 22.4981C13.5288 22.6483 13.6902 22.7948 13.8667 22.9224C14.8467 23.6396 16.0407 24 17.4599 24C19.0106 24 20.3511 23.6396 21.4887 22.9224C22.6227 22.2015 23.505 21.1802 24.1358 19.8548C24.7628 18.5294 25.0782 16.9675 25.0782 15.169C25.0782 13.3705 24.7628 11.7822 24.1358 10.4681M19.9155 17.6321C19.5551 18.3492 19.067 18.9124 18.4474 19.3179C17.8279 19.7234 17.1145 19.9262 16.3073 19.9262C15.5413 19.9262 14.8617 19.7234 14.2685 19.3179C13.6715 18.9162 13.2059 18.353 12.8717 17.6321C12.5338 16.9149 12.3648 16.0926 12.3648 15.1727C12.3648 14.2528 12.5338 13.4381 12.8717 12.7284C13.2059 12.0188 13.679 11.4631 14.2872 11.0613C14.8917 10.6558 15.5788 10.4568 16.3448 10.4568C17.1521 10.4568 17.8692 10.6521 18.485 11.0463C19.1045 11.4368 19.5851 11.9963 19.9343 12.7134C20.2835 13.4305 20.4562 14.2528 20.4562 15.1727C20.4562 16.0926 20.276 16.9149 19.9155 17.6321Z'
                fill='#FF2733'
            />
        </SvgElement>
    )
);
